import validators from '../../../utils/validators';
import DrugCatalog from '../catalog';

class DrugPrescriptionIngredient {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      name: (v) => validators.isNotEmptyString(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid DrugPrescriptionIngredient property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    try {
      this.catalog = new DrugCatalog(data.catalog);
    } catch (e) {
      throw new Error(`Error in DrugPrescriptionIngredient in ${data.id}: ${e.message}`);
    }
  }
}

export default DrugPrescriptionIngredient;
